import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function atLeastOneCheckboxValidator(
  checkboxes: string[]
): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const isChecked = checkboxes.some(field => formGroup.get(field)?.value);
    return isChecked ? null : { atLeastOneRequired: true };
  };
}